import { Typography } from '@mui/material';
import { t } from 'i18next';

type Props = {
  total: number;
};

type Variant = 'h4' | 'h5' | 'h6';

export const ChartTooltip = ({ total }: Props) => {
  let variant: Variant = 'h4';
  if (total >= 10_000) {
    variant = 'h5';
  } else if (total >= 1_000_000) {
    variant = 'h6';
  }

  return (
    <div style={{ textAlign: 'center' }} data-role="chart-tooltip">
      <Typography variant="caption">{t('total')}:</Typography>
      <Typography variant={variant} component="div" sx={{ lineHeight: 1 }}>
        {total.format()}
      </Typography>
    </div>
  );
};
